// extracted by mini-css-extract-plugin
export var clauseRow = "_4x-6";
export var emptyState = "_4x-d";
export var filterContent = "_4x-a";
export var filterGroup = "_4x-1";
export var filterGroupContainer = "_4x-0";
export var nestedGroup = "_4x-2";
export var nestedGroupContent = "_4x-b";
export var nestedGroupDepth1 = "_4x-3";
export var nestedGroupDepth2 = "_4x-4";
export var nestedGroupDepth3 = "_4x-5";
export var nestedGroupEmpty = "_4x-c";
export var operatorAnd = "_4x-8";
export var operatorOr = "_4x-9";
export var operatorToggle = "_4x-7";
export var removeGroupButton = "_4x-e";